module.exports = __webpack_public_path__ + "img/SOKAL-SRS-121021-Aviator-Modern.8b5b41ef.jpeg";